<h2 mat-dialog-title>Log details</h2>
<mat-dialog-content>
    <h3>Request</h3>
    <div>
        Url: <code>{{ data.webhookLog.url }}</code>
    </div>
    <div>
        Headers:
        <ul>
            @for (header of data.webhookLog.requestHeaders; track $index) {
                <li>{{ header.name }}: {{ header.value }}</li>
            } @empty {
                No headers
            }
        </ul>
    </div>
    <div>
        Body:
        <pre>{{ data.webhookLog.requestBody }}</pre>
    </div>
    <h3>Response</h3>
    <div>
        Status: <code>{{ data.webhookLog.statusCode }}</code>
    </div>
    <div>
        Headers:
        <ul>
            @for (header of data.webhookLog.responseHeaders; track $index) {
                <li><code>{{ header.name }}</code>: <code>{{ header.value }}</code></li>
            } @empty {
                No headers
            }
        </ul>
    </div>
    <div>
        Body:
        <pre>{{ data.webhookLog.responseBody }}</pre>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button [mat-dialog-close]="undefined" mat-button>Cancel</button>
</mat-dialog-actions>
